<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap">
            <el-form-item label="任务名称">
                <el-input v-model="formInline.user" placeholder="任务名称"></el-input>
            </el-form-item>
            <el-form-item label="分组">
                <el-select v-model="formInline.region" placeholder="活动区域">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="getQuartzList" align="center" height="700px" style="width:100%" v-loading="loading" >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="job_name" label="姓名"></el-table-column>
            <el-table-column prop="job_group" label="性别"></el-table-column>
            <el-table-column prop="description" label="描述"></el-table-column>
            <el-table-column prop="start_time" label="开始时间" sortable></el-table-column>
            <el-table-column prop="next_fire_time" label="结束时间" sortable></el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, getQuartzList)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10,15,20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="姓名">
                    <el-input v-model="form.job_name"></el-input>
                </el-form-item>
                <el-form-item label="性别">
                    <el-input v-model="form.job_group"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input v-model="form.description"></el-input>
                </el-form-item>
                <el-form-item label="开始时间">
                    <el-date-picker
                            v-model="form.start_time"
                            value-format="yyyy-MM-dd HH-mm-ss"
                            type="datetime"
                            placeholder="选择开始日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker
                            v-model="form.next_fire_time"
                            value-format="yyyy-MM-dd HH-mm-ss"
                            type="datetime"
                            placeholder="选择结束日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getQuartzList,getSysUserMenu} from '../api/api'
    export default{
        data(){
            return {
                getQuartzList:[],
                loading:true,
                currentPage:1,
                recordsTotal:0,
                pageSize:15,
                options: [{
                    value: '选项1',
                    label: '选项1'
                }, {
                    value: '选项2',
                    label: '选项2'
                }, {
                    value: '选项3',
                    label: '选项3'
                }, {
                    value: '选项4',
                    label: '选项4'
                }, {
                    value: '选项5',
                    label: '选项5'
                }],
                selectValue: '',
                dialogFormVisible:false,
                form:{
                    "trigger_name":"",
                    "start_time":"",
                    "sched_name":"",
                    "job_name":"",
                    "job_group":"",
                    "end_time":"",
                    "description":"",
                    "prev_fire_time":"",
                    "next_fire_time":"",
                    "trigger_group":"",
                    "status":""
                },
                formInline:{
                    "job_name":"",
                    "job_group":"",
                }
            }
        },
        mounted(){
            this.getList(this.currentPage,this.pageSize);
//            getSysUserMenu({}).then((res) => {
//                console.log(res)
//            })
        },
        methods:{
            getList(page,count){
                getQuartzList({pageNum:page,length:count}).then((res) => {
                    this.loading = false;
                    this.getQuartzList = res.data.list;
                    this.recordsTotal = res.data.recordsTotal;
                })
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getList(1,val)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getList(val,this.pageSize)
            },
            handleEdit(index,row){
                this.dialogFormVisible = true;
                this.form = row;
            },
            handleDel(index,rows){
                rows.splice(index,1)
            },
            handleAdd(){
                this.dialogFormVisible = true;

            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .el-table{
        color: #222222;
    }
    .el-table th{
        background: #eef1f6;
        color: #222222;
    }
    .select-wrap{
        margin: 10px 20px;
    }
    .pagination-wrap{
        text-align: right;
        margin: 20px;
    }
    .select-wrap .el-form-item{
        margin-bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// src/views/basetable.vue